import React, { FC } from 'react'

import { useTranslation } from 'react-i18next'

import styles from './FullTourStepThree.module.scss'
import { TourSourceCard } from './FullTourStepThree.types'

export const FullTourStepThree: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_three'
  })
  const sources = t('sources', { returnObjects: true }) as TourSourceCard[]

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-three-title'
      aria-describedby='full-tour-step-three-description'
    >
      <div className={styles.tourMain}>
        <div className={styles.tourLeft}>
          <div className={styles.tourHeading}>
            <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-step-three-title' className={styles.tourTitle}>
              <span>{t('title_before')}</span>
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <p
            id='full-tour-step-three-description'
            className={styles.tourDescription}
          >
            {t('description')}
          </p>
        </div>

        <div className={styles.sources}>
          {sources.map(source => (
            <article key={source.label} className={styles.sourceCard}>
              <p className={styles.sourceLabel}>{source.label}</p>
              <h2>{source.title}</h2>
              <p className={styles.sourceDescription}>{source.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
